var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterMediaActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.0063C26 20.1679 20.1651 26 13 26C5.83494 26 0 20.1679 0 13.0063C0 5.83213 5.83494 0 13 0C20.1651 0 26 5.83213 26 13.0063Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2006 13.0062C18.2006 13.3348 18.0972 13.6646 17.8904 13.9287C17.8516 13.9805 17.6706 14.1941 17.5284 14.3331L17.4509 14.4089C16.3651 15.5601 13.6635 17.2913 12.2933 17.8461C12.2933 17.8587 11.479 18.1886 11.0912 18.1999H11.0395C10.4449 18.1999 9.88908 17.8726 9.60471 17.3419C9.44959 17.05 9.3074 16.2033 9.29448 16.192C9.17814 15.4325 9.10059 14.2699 9.10059 12.9936C9.10059 11.6554 9.17814 10.441 9.32033 9.69543C9.32033 9.68279 9.46252 9.00041 9.553 8.77295C9.69519 8.44566 9.95371 8.16639 10.2769 7.98948C10.5354 7.86437 10.8068 7.79993 11.0912 7.79993C11.3885 7.81383 11.9443 8.00211 12.1641 8.09057C13.6118 8.64659 16.378 10.4663 17.4379 11.5783C17.6189 11.7552 17.8128 11.9713 17.8645 12.0206C18.0843 12.2986 18.2006 12.6398 18.2006 13.0062Z",
    fill: "#14151A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMediaActive);
export default __webpack_public_path__ + "static/media/footer_media_active.6fd1b6e3bfb0b13e2f2757e4efe5871c.svg";
export { ForwardRef as ReactComponent };